export const servicesConfig = {
  "Ziemia ogrodowa (czarnoziem)": {
    key: "ziemia_ogrodowa",
    price: 1500,
    description: "Żyzna, przesiana ziemia idealna pod trawniki i ogrody.",
    name: "Ziemia ogrodowa (czarnoziem)"
  },
  "Piasek zasypowy": {
    key: "piasek",
    price: 800,
    description: "Stabilna baza pod budowę – idealny do zasypek, fundamentów i wyrównania terenu.",
    name: "Piasek zasypowy"
  },
  "Kruszywo drogowe (certyfikowane)": {
    key: "kruszywoCert",
    price: 2000,
    description: "Wytrzymałe i certyfikowane – pod drogi, podjazdy i miejsca wymagające maksymalnej trwałości.",
    name: "Kruszywo drogowe (certyfikowane)"
  },
  "Kruszywa betonowe (przekrusz)": {
    key: "kruszywo",
    price: 1500,
    description: "Tańsza alternatywa pod utwardzenie terenu – solidne i ekonomiczne rozwiązanie.",
    name: "Kruszywa betonowe (przekrusz)"

  },
  "Ziemia na podniesienie terenu": {
    key: "ziemia_podniesienie",
    price: 500,
    description: "Najlepsza opcja do szybkiego wyrównania i podniesienia działki – dużo, tanio i skutecznie.",
    name: "Ziemia na podniesienie terenu"
  }
};